import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useEffect, useState } from 'react';
import { EEScorecardService } from '../../Component/Api/EmploymentEquity/Scorecard/EEScorecardService';
import { MDTypography } from "../../Component/Common/Components/MDTypography";
import { EEScorecard } from '../../Component/Model/Dto/EmploymentEquity/EEScorecard';
import { defaultObject } from '../../Helpers/typescriptHelper';
import { CustomDialogTitle } from '../Common/Custom/CustomDialogTitle';

interface IProps {
    scorecardId: string;
    showPendingScorecardModal: boolean;
    closePendingScorecardModal: () => void;
}

export const PendingSubmissionModal = (props: IProps) => {

    const [metaData, setMetaData] = useState<EEScorecard.MetaDto>(defaultObject);

    const fetchData = async () => {
        if (props.scorecardId) {
            let meta = await EEScorecardService.GetScorecardMeta(props.scorecardId);
            if (meta.data) {
                setMetaData(meta.data)
            }
        }
    }

    useEffect(() => {
        fetchData();
    }, [props.scorecardId]);

    return (
        <Dialog disableEnforceFocus open={props.showPendingScorecardModal} onClose={() => { props.closePendingScorecardModal() }} aria-labelledby="form-dialog-title" maxWidth='lg'>
            <CustomDialogTitle id="assign-dialog-title" onClose={() => props.closePendingScorecardModal()}>
                Scorecard Already Submitted for Verification
            </CustomDialogTitle>
            <DialogContent sx={{ width: '530px' }}>
                <MDTypography variant='subtitle'>
                    Please contact <strong>{metaData.verificationAgencyName}</strong> regarding the acceptance or rejection of your previous scorecard submission.
                </MDTypography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    color='primary'
                    sx={{ marginRight: '10px' }}
                    onClick={() => props.closePendingScorecardModal()}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}